export { default } from './useTheme';


//////////////////
// WEBPACK FOOTER
// ./node_modules/@material-ui/styles/esm/useTheme/index.js
// module id = 51
// module chunks = 0